export default "/images/vendor/flag-icons/flags/1x1/es-ga.svg?091af445da938e870d37b32bce031c8d";